// src/components/Navbar.js
import React from 'react';
import { NavLink } from 'react-router-dom';
import { Navbar as BootstrapNavbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css'; // Импортируем Bootstrap
import '../css/Navbar.css';

function Navbar() {

  return (
    <div className="navbar-wrapper">
      <BootstrapNavbar expand="lg" className="navbar-container">
          <div className="container-fluid">
            <div className="logo-container">
              <NavLink to="/" className="navbar-brand d-flex align-items-center">
                <img src="/logo.svg" alt="Logo" className="navbar-logo" />
              </NavLink>
            </div>
            <BootstrapNavbar.Toggle aria-controls="navbar-content" className="navbar-toggler">
              <FontAwesomeIcon icon={faBars} />
            </BootstrapNavbar.Toggle>
            <div className="col-12 col-lg-12 d-flex align-items-center">
              <BootstrapNavbar.Collapse id="navbar-content">
                <Nav className="custom-nav">
                  <Nav.Link as={NavLink} to="/" end className={({ isActive }) => isActive ? 'active' : ''}>Violations</Nav.Link>
                  <Nav.Link as={NavLink} to="/submit-complaint" end className={({ isActive }) => isActive ? 'active' : ''}>Submit a Complaint</Nav.Link>
                  <Nav.Link as={NavLink} to="/employee-rights" end className={({ isActive }) => isActive ? 'active' : ''}>Employee Rights</Nav.Link>
                </Nav>
              </BootstrapNavbar.Collapse>
            </div>
          </div>
      </BootstrapNavbar>
    </div>
  );
}

export default Navbar;